import {MasterService} from './../services/master.service';
import {filter} from 'rxjs/operators';
import {StockService} from './../services/stocks.service';
import {Component, OnInit, Input, Output, Injectable} from '@angular/core';
import {PageEvent} from '@angular/material/paginator';
import {NgForm} from '@angular/forms';
import {PaginationInstance} from 'ngx-pagination';
import {ActivatedRoute} from '@angular/router';
import {CommonAlertService} from '../../services/common-alert.service';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { BASE_URL } from '../../config/config';


@Component({
  selector: 'app-analytics',
  templateUrl: './analytics.component.html',
  styleUrls: ['./analytics.component.scss']
})
export class AnalyticsComponent implements OnInit {
  public stockData: any;
  public proName: any;
  public bodyPart: any;
  public implant: any;
  public stockLocation: any;
  public stockLocationItem: any;
  public stockCity: any;
  public regionData: any;
  public countryData: any;
  public cityData: any;
  public city: any;
  public selectedRegionM: any = 1;
  public selectedCountryM: any;
  public selectedCityM: any;
  public selectedTypeM: string;
  public stocksFrmAPI: any;
  public stocksFrmAPILoc: any;
  public stockFlag = false;
  public stockLength: any;
  // paginationId: boolean = false;
  public filter: any;
  public searchData: any;
  public searchBy: any = 0;
  public searchTxt: any;
 
  public report: any;
  placeHolder: any = 'Search By Product Name';
  // tslint:disable-next-line:variable-name
  total_count: any;
  // tslint:disable-next-line:variable-name
  current_page: any;
  selectedValue: any;
  pageEvent: PageEvent;
  stockPageId = 'stockPageId';
  // tslint:disable-next-line:variable-name
  per_page: number;
  itemToBePushed: any;
  // tslint:disable-next-line:variable-name
  last_page: any;
  pageIndex: any;
  selectedIndex = 0;
  page: any = 1;
  public BASE = BASE_URL.URL;

  public headObj = {
    datePick: '',
    coutry: '',
    warehouse: '',
    batchNo: ''
  };


  public config: PaginationInstance = {
    id: 'custom',
    itemsPerPage: 10,
    currentPage: 1
  };
  public viewPermission = false;

  constructor(
    public stockService: StockService,
    public masterService: MasterService,
    public route: ActivatedRoute,
    public commonAlertService: CommonAlertService) {
    this.selectedTypeM = '';
    if (this.route.snapshot.queryParamMap.get('billed')) {
      this.selectedTypeM = 'is_billed';
    }
    if (this.route.snapshot.queryParamMap.get('pending')) {
      this.selectedTypeM = 'is_pending';
    }
  }

  ngOnInit() {
    // @ts-ignore
    // tslint:disable-next-line:triple-equals
    if (localStorage.getItem('roleId') == 0) {
      // @ts-ignore
      // tslint:disable-next-line:max-line-length
      this.viewPermission = true;
    } else {
      const roles = JSON.parse(localStorage.getItem('roles'));
      // tslint:disable-next-line:triple-equals
      if (roles['stock.view'] == 1) {
        this.viewPermission = true;
      }
    }
    let url: string;
    url = '/regions/get';
    this.masterService.getData(url).subscribe(res => {
      // @ts-ignore
      this.regionData = res.data;
      this.selectedRegionM = this.regionData[0].id;
      this.selectedRegion(this.regionData[0].id);

     });
 }

  submitFormReport(data) {
    // tslint:disable-next-line:variable-name max-line-length
      const url = this.BASE + '/reports?type=' + data.type + '&start_date=' + data.start_date + '&end_date=' + data.end_date;
      this.masterService.downloadFiles(url);
     

  }
  submitFormStock(data) {
    // tslint:disable-next-line:variable-name max-line-length
    const url = this.BASE + '/stocks/downloadstock?location_id=' + data.city;
    this.masterService.downloadFiles(url);
     console.log (data.city); 
       

  }

  getCurrentDate() {
    const today = new Date();
    let dd: any = today.getDate();
    let mm: any = today.getMonth() + 1;
    const yyyy = today.getFullYear();
    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }

    return this.headObj.datePick = dd + '/' + mm + '/' + yyyy;
  }

  openDialog() {

  }

  downloadReportFile() {

  }

selectedRegion(val) {
    /* TO GET COUNTRIES */
    const url = '/countries/get';
    const selectedRegionDrp = val;
    this.masterService.getData(url).subscribe(res => {
      // tslint:disable-next-line:triple-equals
      // @ts-ignore
      // tslint:disable-next-line:triple-equals
      this.countryData = res.data.filter(reg => reg.region_id == selectedRegionDrp);
      this.selectedCountryM = this.countryData[0].id;
      this.selectedCountry(this.selectedCountryM);
    });
  }

  selectedCountry(val) {
    /* TO GET CITIES */
    const url = '/locations/get';
    const selectedCountry = val;
    this.masterService.getData(url).subscribe(res => {
      // tslint:disable-next-line:triple-equals
      // @ts-ignore
      // tslint:disable-next-line:triple-equals
      this.cityData = res.data.filter(city => city.country_id == selectedCountry);
      this.selectedCityM = this.cityData[1].country_id;
      this.selectedCity(this.selectedCityM);
    });
  }


  selectedCity(val) {
    this.selectedValue = val;
    this.filter = {
      region_id: this.selectedRegionM,
      country_id: this.selectedCountryM,
      location_id: this.selectedCityM,
      type: this.selectedTypeM,
      token: localStorage.getItem('token')
    };
    this.getStocksData();
  }

  selectedType(val) {
    this.selectedValue = val;
    this.filter = {
      region_id: this.selectedRegionM,
      country_id: this.selectedCountryM,
      location_id: this.selectedCityM,
      type: val,
      token: localStorage.getItem('token')
    };
    this.getStocksData();
  }

  getStocksData() {
    this.masterService.getIndex('/stocks/index', this.filter).subscribe(res => {
      // @ts-ignore
      this.stockData = res.data;
      // @ts-ignore
      this.stockLocationItem = res.data.items;
      // @ts-ignore
      this.stockLocation = res.data.locations;
      // @ts-ignore
      this.stockCity = res.data.items.map(r => r.stockData);
      // @ts-ignore
      this.stocksFrmAPI = res.data.items;
      // @ts-ignore
      this.stocksFrmAPILoc = res.data.location;
      // @ts-ignore
      this.stockLength = res.data.location.stores.length;
      // @ts-ignore
      this.total_count = res.data.total;
      // @ts-ignore
      this.per_page = res.data.per_page;
      // @ts-ignore
      this.current_page = res.data.current_page;
      if (this.stockLocationItem.length < 10) {
        // tslint:disable-next-line:prefer-const
        let stockData = [];
        for (let j = 0; j < this.stockLength; j++) {
          // @ts-ignore
          stockData.push({stock: ''});
        }
        const newData = {
          product_name: '',
          body_part_name: '',
          stockCity: '',
          stocksFrmAPI: '',
          stocksFrmAPILoc: '',
          stockData
        };
        for (let i = 0; i < 10; i++) {
          this.stockLocationItem.push(newData);
        }
      }
      // @ts-ignore
      if(res.data.total == 0){
       this.commonAlertService.showEmptyMsg({message: 'No Details Found.'})
      }
    });
  }




}
